import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { MAT_SELECTSEARCH_DEFAULT_OPTIONS, MatSelectSearchOptions } from 'ngx-mat-select-search';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

const matSelectSearchDefaults: MatSelectSearchOptions = {
  placeholderLabel: 'Buscar…',
  noEntriesFoundLabel: 'Sin coincidencias',
};

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot({
      positionClass: 'toast-top-right',
      timeOut: 3000,
      extendedTimeOut: 1000,
      progressBar: true,
      preventDuplicates: true,
      closeButton: true
    })
  ],
  providers: [
    { provide: MAT_SELECTSEARCH_DEFAULT_OPTIONS, useValue: matSelectSearchDefaults },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
